import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

export function useEventTags(eventId) {
    const selector = useCallback((state) => state.events[eventId]?.tags, [eventId]),
        tags = useSelector(selector) ?? [];
    return useMemo(() => tags ?? [], [tags]);
}
